import React, { Fragment, useState, useEffect } from "react";
import { useQuery } from '@tanstack/react-query';
import { Tooltip } from 'react-tooltip';

import { getLifeform, createDeathform } from '../services/api';
import GoodDeathForm from "./GoodDeathForm";
import GoodDeathMint from "./GoodDeathMint";
import translate from "../services/translate";
import Loader from "./Loader";

const LifeformInfo = ({ tokenId, address, setMinted }) => {
  const [metadata, setMetadata] = useState(null);
  let [birth, setBirth] = useState(0);
  let [hours, setHours] = useState(0);
  let [days, setDays] = useState(0);
  let [creator, setCreator] = useState("");
  let [extra, setExtra] = useState("");

  const { data, error, isFetching } = useQuery({
    queryKey: ['lifeforms'],
    queryFn: async () => getLifeform(tokenId)
  })

  useEffect(() => {
    if (data) {
        const deltatime = Date.now() - Number(data.birth);
        setDays(Math.floor(deltatime / 86400000));
        setHours(Math.floor((deltatime - (Math.floor(deltatime / 86400000)) * 86400000) / 3600000));
        setBirth(new Date(Number(data.birth)));
        let creation = data.memoryformlifeforms.find(i => i.created === true);
        if (creation && creation.memoryform.address === address.toLowerCase()) {
          setCreator("you");
        } else {
          setCreator(creation.memoryform.address);
        }
        let me = data.memoryformlifeforms.find(i => i.memoryform.address === address.toLowerCase());
        if (me && me.interactionCount === 1) {
          setExtra(`You have only cared for this lifeform once. `);
        } else if (me) {
          setExtra(`You have cared for this lifeform ${me.interactionCount} times. `);
        }
    }
  }, [data, setBirth, setHours, setDays, address])

  const onSubmit = async (data) => {
    try {
      let msg;
      if (!data.maintext) {
        msg = "";
      } else {
        msg = data.maintext;
      }
      const response = await createDeathform({ address: address.toLowerCase(), msg, tokenId })
      setMetadata(response.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Fragment>
    {isFetching && !error ? <Loader /> : 
        error ? <p>Something went wrong ...</p> : 
        <div className="fullsize">
          <div className="container">
            <div id="memoryImg" dangerouslySetInnerHTML={{ __html: data.svg }} />
            <div className="half">
              <div className="memoryformIntro">
                {!metadata && (
                  <Fragment>
                    <Tooltip
                    id="gooddeathtippy"
                    style={{ backgroundColor: "rgb(0, 0, 0)", color: "white", padding: "1rem", borderRadius: "20px"}}
                  />
                  { birth && <p>{translate('LifeformInfo.mainpara', {
                    tokenId: data.tokenId,
                    creator,
                    birth: birth.toDateString(),
                    total: data.totalTransfers,
                    caretakers: data.totalCaretakers,
                    extra,
                    days,
                    hours
                  })}</p>}
                  {data.archetypes.length > 0 ? (
                    <p>{`Lifeform #${data.tokenId}'s archetypes were: `}
                      {data.archetypes.map((i) => {
                        return (
                          <Fragment key={i}>
                          <a key={i.id} className="carePat" data-tooltip-id="gooddeathtippy" data-tooltip-content={translate(`archetypes.${[i]}`)}>
                            {`${i}${data.archetypes[data.archetypes.length-1] === i ? "" : ", "}`}
                          </a>
                          </Fragment>
                        )
                      })
                    }</p>) : null}
                  </Fragment>)}
                  { metadata ? <GoodDeathMint data={{...metadata, tokenId}} setMinted={setMinted} /> : (
                    <GoodDeathForm
                    lifeform={data}
                    prompt={`Do you want to send a message with Lifeform #${tokenId}? This is optional, if included it will be added to the metadata.`}
                    onSubmit={onSubmit}/>
                  )}
                </div>
            </div>
          </div>
        </div>
    }
    </Fragment>
  )
}

export default LifeformInfo;